/**
 * Newsletter component.
 * @module components/Newsletter/Newsletter
 */

import { useState } from 'react';
import { useIntl, defineMessages, FormattedMessage } from 'react-intl';
import { Button } from 'semantic-ui-react';
import { UniversalLink } from '@plone/volto/components';

const messages = defineMessages({
  labelEmail: {
    id: 'Email address',
    defaultMessage: 'Email address',
  },
  warningMessage: {
    id: 'Your data will be treated according to our privacy policy.',
    defaultMessage: 'Your data will be treated according to our privacy policy.',
  },
  loading: {
    id: 'Loading...',
    defaultMessage: 'Carregant...',
  },
  subscribe: {
    id: 'Subscribe',
    defaultMessage: 'Subscriu-te',
  },
  success: {
    id: 'Successfully subscribed!',
    defaultMessage: 'T’has subscrit correctament!',
  },
  error: {
    id: 'Something went wrong. Please try again.',
    defaultMessage: 'Alguna cosa ha anat malament. Torna-ho a provar.',
  },
});

const Newsletter = () => {
  const intl = useIntl();
  const [email, setEmail] = useState('');
  const [privacyAccepted, setPrivacyAccepted] = useState(false);
  const [status, setStatus] = useState(null); 

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus('loading');

    try {
      const response = await fetch('/subscribe-newsletter', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
        }),
      });

      if (response.ok) {
        setStatus('success');
        setEmail('');
        setPrivacyAccepted(false);
      } else {
        setStatus('error');
      }
    } catch (e) {
      setStatus('error');
    }
  };

  return (
    <form className="ui form newsletter__form text-start" onSubmit={handleSubmit}>
      <label htmlFor="newsletter-input" className="fw-bold mb-0 d-block">
        <FormattedMessage
          id="Subscriu-te al butlletí"
          defaultMessage="Subscriu-te al butlletí"
        />
      </label>

      <div className="newsletter__wrapper mb-4">
        <input
          id="newsletter-input"
          required
          className="newsletter__input"
          autoComplete="email"
          placeholder={intl.formatMessage(messages.labelEmail)}
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={status === 'loading'}
        />
        <Button
          type="submit"
          className="newsletter__btn"
          disabled={status === 'loading'}
        >
          {status === 'loading' ? (
            intl.formatMessage(messages.loading)
          ) : (
            intl.formatMessage(messages.subscribe)
          )}
        </Button>
      </div>

      <label className="d-block text-start pt-2">
        <input
          type="checkbox"
          id="privacyPolicy-footer"
          className="me-2"
          required
          checked={privacyAccepted}
          onChange={(e) => setPrivacyAccepted(e.target.checked)}
        />
        <FormattedMessage
          id="He llegit i accepto la"
          defaultMessage="He llegit i accepto la"
        />{' '}
        <UniversalLink
          className="text-decoration-underline"
          href="/politica-de-privacitat"
        >
          <FormattedMessage
            id="política de privacitat"
            defaultMessage="política de privacitat"
          />
        </UniversalLink>
      </label>

      {status === 'success' && (
        <p className="newsletter__success mt-2">
          {intl.formatMessage(messages.success)}
        </p>
      )}
      {status === 'error' && (
        <p className="newsletter__error mt-2">
          {intl.formatMessage(messages.error)}
        </p>
      )}

      <p className="newsletter__warning">
        {intl.formatMessage(messages.warningMessage)}
      </p>
    </form>
  );
};

export default Newsletter;